import React from 'react';

const Tool02Panel = ({ toolProps, onUpdate, clearPaths, downloadSVG }) => {
  const { svgWidth, svgHeight } = toolProps;

  const handleChange = (key, value) => {
    onUpdate(key, value);
  };

  return (
    <div className="panel">
      <h2>Poster</h2>
      <div className="panel-controls">
        <div className="control-group">
          <label>Poster Width:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1660"
              value={svgWidth}
              onChange={(e) => handleChange('svgWidth', Number(e.target.value))}
            />
            <span>{svgWidth}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Poster Height:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1110"
              value={svgHeight}
              onChange={(e) => handleChange('svgHeight', Number(e.target.value))}
            />
            <span>{svgHeight}</span>
          </div>
        </div>
      </div>

      <div className="panel-footer">
        <button className="action-btn" onClick={clearPaths}>
          Clear Paths
        </button>
        <button className="action-btn" onClick={downloadSVG}>
          Download SVG
        </button>
      </div>
    </div>
  );
};

export default Tool02Panel;
